import { useMediaQuery } from '@mui/material';

export const useMediaQueryMobile = (maxWidth: number = 767) => {
  return useMediaQuery(`(max-width: ${maxWidth}px)`);
};
